<template lang="pug">
.outstanding-list
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.align-items-end.px-4.py-4
        //- CustomCategoriesFilter(
        //-   title='เลือกดูตามเขต'
        //- //-   :items='statusList'
        //- //-   v-model='filterArea'
        //- //- )
        CustomAreaFilter(
          title='เลือกดูตามเขต'
          v-model='filterArea'
        )
        PanelTitleRight.ml-auto(
          title='รายการค้างชำระ'
          :subtitle='tableData ? `${totalRows} รายการ`:`...`'
          :displayDatePicker="false"
        )

      .px-4.py-2
        //- div.mb-3
        //-   .text-15 ยอดค้างชำระ
        //-   .text-21.text-bold.red {{ totalOutstandingAmount | currency }}
        .w-100
          CustomSearchBox.ml-auto(
            v-model='filterSearch'
            type='text' placeholder='ค้นหาด้วยเลขที่รายการ'
            :isLoading='isLoading'
            width='100%'
          )
            i.fa.fa-search

      hr.mb-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3.flex-fill
        CustomTable(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :showNotificationDots='true'
          @itemClicked='showModal'
        )

      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )
  modal(
    name='sell-record'
    width='90%' height='95%'
    transition='modal-transition'
  )
    CSSellRecordDetail(
      v-if='selectedItem'
      :sellRecord='selectedItem.order'
      @closeButtonClicked='hideModal'
    )
</template>

<script>
/* eslint-disable arrow-body-style */
import CustomerCompactDetailHeader from '@/components/customers/CustomerCompactDetailHeader.vue';
import CSSellRecordDetail from '@/components/_cs/sell-records/dialogs/SellRecord/CSSellRecordDetail.vue';

export default {
  // props: {
  // },
  // watch: {
  //   customer(newVal) {
  //     this.loadData(newVal);
  //   },
  // },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.trim().toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     (!KEYWORD
      // search only with customer name, since this will affect the 'totalOutstandingAmount'
      // multiple search fields might show a mixed-up totalAmount.
      // i.e. a customer named 'Rose' & company with the word 'Rose' in the name.
      //       || (item.customer.name && item.customer.name.toUpperCase().includes(KEYWORD))
      //     )
      //     && (!this.filterArea
      //       || (item.customer.zone && item.customer.zone.toString() === this.filterArea)
      //     )
      //     && (this.filterDate === '' || this.$dateUtils.isInRange(item.dueDate, this.filterDate))
      //   );
      // });
      return this.tableData;
    },
  },
  watch: {
    // filteredTableData(newVal) {
    tableData(newVal) {
      let total = 0;
      if (this.tableData) {
        for (let i = 0; i < newVal.length; i += 1) {
          total += newVal[i].total;
        }
      }
      this.totalOutstandingAmount = total;
    },

    // reload data
    filterDate: {
      handler() { this.currentPage = 1; this.loadData(); },
      deep: true,
    },
    filterArea() { this.currentPage = 1; this.loadData(); },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  data() {
    return {
      isLoading: false,

      // statusList: {
      //   NE: 'NE',
      //   NW: 'NW',
      //   SE: 'SE',
      //   N: 'N',
      //   C: 'C',
      // },
      filterArea: '',

      filterDate: '',
      filterSearch: '',
      tableData: [],
      tableColumns: {
        dueDate: {
          title: 'กำหนดจ่าย',
          align: 'left',
          type: Date,
        },
        entryNo: {
          title: 'เลขที่รายการ',
          align: 'left',
          type: 'EntryNo',
        },
        zone: {
          title: 'เขต',
          align: 'center',
          computed: (row) => {
            if (row.customer) {
              return row.customer.zone;
            }
            return '';
          },
        },
        customerName: {
          title: 'ชื่อลูกค้า',
          align: 'left',
          computed: (row) => {
            if (row.customer) {
              return row.customer.name;
            }
            return '';
          },
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
        },
        daysPastDue: {
          title: 'วันที่เกิน',
          align: 'right',
          // type: Number,
          computed: row => ((parseInt(row.daysPastDue, 10) < 0) ? 0 : row.daysPastDue),
        },
        sellDate: {
          title: 'วันที่ทำรายการ',
          align: 'center',
          type: Date,
        },
        sellerName: {
          title: 'ผู้ขาย',
          align: 'right',
          computed: (row) => {
            if (row.order && row.order.user) {
              return row.order.user.name;
            }
            return '';
          },
        },
      },

      // pagination
      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},

      totalOutstandingAmount: 0,
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // const res = await this.$api.cs.sellRecord.unpaid();
      // if (res.status === 200) {
      //   this.tableData = res.data.data;
      // }

      try {
        const res = await this.$api.billing.outstandings(
          undefined, // this.customer.id,
          this.currentPage,
          this.filterSearch,
          this.filterArea,
        );

        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.isLoading = false;
    },
    showModal(e) {
      this.selectedItem = e.data;
      this.$modal.show('sell-record');
    },
    hideModal() {
      // // console.log('close');
      this.$modal.hide('sell-record');
      this.loadData();
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();
  },
  components: {
    CustomerCompactDetailHeader,

    CSSellRecordDetail,
  },
};
</script>

<style lang="scss">
.outstanding-list {
  .panel-title {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 24px;
  }
  .panel-subtitle {
    font-weight: 300;
    letter-spacing: 1px;
    font-size: 17px;
  }
}
</style>
